import { render } from "./SubscriptionFeatureChecksPanel.vue?vue&type=template&id=5f5bf3c6"
import script from "./SubscriptionFeatureChecksPanel.vue?vue&type=script&lang=js"
export * from "./SubscriptionFeatureChecksPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__